import isEmpty from 'lodash/isEmpty';

export function getGroupValue(state) {
  const { group } = state.navigationSelection;

  if (isEmpty(group)) {
    return '';
  }

  const value = {
    value: group.groupId,
    label: group.groupName,
  };

  return value;
}

export function getPurposeValue(state) {
  const { purpose } = state.navigationSelection;

  if (isEmpty(purpose)) {
    return '';
  }

  const value = {
    value: purpose.sectionName,
    label: purpose.sectionName,
  };

  return value;
}

export function getPageValue(state) {
  const { page } = state.navigationSelection;

  if (isEmpty(page)) {
    return '';
  }

  const value = {
    value: page.pageId,
    label: page.name,
  };

  return value;
}
